import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import Navbar from '../Navbar/Navbar';
import './MainLayout.css';

function MainLayout() {
    const [collapsed, setCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const location = useLocation();

    // Close mobile menu on route change
    useEffect(() => {
        setMobileOpen(false);
    }, [location.pathname]);

    // Auto collapse on small screens
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 900) {
                setCollapsed(false);
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className={`layout ${collapsed ? 'sidebar-collapsed' : ''}`}>
            <Sidebar
                collapsed={collapsed}
                onToggle={() => setCollapsed(p => !p)}
                mobileOpen={mobileOpen}
                onMobileClose={() => setMobileOpen(false)}
            />

            <div className="layout-main">
                <Navbar
                    onMobileMenuToggle={() => setMobileOpen(p => !p)}
                    mobileOpen={mobileOpen}
                    sidebarCollapsed={collapsed}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                />

                <main className="layout-content">
                    <div className="animate-in">
                        <Outlet context={{ searchQuery }} />
                    </div>
                </main>
            </div>
        </div>
    );
}

export default MainLayout;